// import React, { useState } from "react";
// import styles from "./Table.module.css";
// // 1. Import React Icons
// import {
//   MdEmail,
//   MdPhone,
//   MdCalendarToday,
//   MdVerifiedUser,
//   MdErrorOutline,
// } from "react-icons/md";
// import StatusBadge from "../StatusBadge/StatusBadge";
// import ActionMenu from "../ActionMenu/ActionMenu";
// import Pagination from "../../Pagination/Pagination";
// import UserAvatar from "../UserAvatar/UserAvatar";

// const Table = ({ users }: { users: any[] }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

//   const handlePageSizeChange = (newSize: number) => {
//     setItemsPerPage(newSize);
//     setCurrentPage(1);
//   };

//   const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

//   return (
//     <div className={styles.tableWrapper}>
//       <table className={styles.table}>
//         <thead>
//           <tr>
//             <th>Customer</th>
//             <th>Mobile</th>
//             <th>Email</th>
//             <th>KYC Status</th>
//             <th>Login Status</th>
//             <th>Created On</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentUsers?.length > 0 ? (
//             currentUsers.map((user: any) => (
//               <tr key={user.CustomerID}>
//                 <td className={styles.nameCell}>
//                   <UserAvatar
//                     src={`${user.ProfileFilePath}${user.ProfileImage}`}
//                     alt={user.CustomerName}
//                   />
//                   <div>
//                     <div className={styles.userName}>
//                       {user.Solutation} {user.CustomerName}
//                     </div>
//                     <div className={styles.userCode}>{user.CustomerCode}</div>
//                   </div>
//                 </td>

//                 {/* Mobile with Icon */}
//                 <td>
//                   <div className={styles.iconWrapper}>
//                     <MdPhone className={styles.rowIcon} />
//                     {user.PrimaryMobile}
//                   </div>
//                 </td>

//                 {/* Email with Icon and Link Functionality */}
//                 <td>
//                   {user.EmailID ? (
//                     <a
//                       href={`mailto:${user.EmailID}`}
//                       className={styles.emailLink}
//                     >
//                       <MdEmail className={styles.rowIcon} />
//                       {user.EmailID}
//                     </a>
//                   ) : (
//                     <span className={styles.notAvailable}>N/A</span>
//                   )}
//                 </td>

//                 <td>
//                   <div className={styles.statusWrapper}>
//                     {user.KYCStatus === "Y" ? (
//                       <MdVerifiedUser color="#4caf50" />
//                     ) : (
//                       <MdErrorOutline color="#ff9800" />
//                     )}
//                     <StatusBadge
//                       status={user.KYCStatus === "Y" ? "Verified" : "Pending"}
//                     />
//                   </div>
//                 </td>

//                 <td>
//                   <StatusBadge
//                     status={user.Status === "Y" ? "Active" : "Inactive"}
//                   />
//                 </td>
//                 <td>
//                   <div className={styles.iconWrapper}>
//                     <MdCalendarToday className={styles.rowIcon} />
//                     {user.CreatedOn}
//                   </div>
//                 </td>

//                 <td>
//                   <ActionMenu />
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td
//                 colSpan={7}
//                 className={[styles.noDataCell, styles.textDanger].join(" ")}
//               >
//                 No users found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       <div className={styles.paginationWrapper}>
//         <Pagination
//           itemsPerPage={itemsPerPage}
//           totalItems={users.length}
//           currentPage={currentPage}
//           onPageChange={paginate}
//           onPageSizeChange={handlePageSizeChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default Table;
import React, { useState } from "react";
import styles from "./Table.module.css";
import {
  MdEmail,
  MdPhone,
  MdCalendarToday,
  MdVerifiedUser,
  MdErrorOutline,
} from "react-icons/md";
import StatusBadge from "../StatusBadge/StatusBadge";
import ActionMenu from "../ActionMenu/ActionMenu";
import Pagination from "../../Pagination/Pagination";
import UserAvatar from "../UserAvatar/UserAvatar";

// --- Sub-Component: Table Skeleton Row ---
const TableSkeleton = ({ rows = 5 }: { rows?: number }) => {
  return (
    <>
      {[...Array(rows)].map((_, i) => (
        <tr key={i}>
          <td className={styles.nameCell}>
            <div
              className={`${styles.skeleton} ${styles.skeletonAvatar}`}
            ></div>
            <div style={{ flex: 1 }}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "70%" }}
              ></div>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "40%", height: "10px" }}
              ></div>
            </div>
          </td>
          <td>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "80%" }}
            ></div>
          </td>
          <td>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "90%" }}
            ></div>
          </td>
          <td>
            <div className={`${styles.skeleton} ${styles.skeletonBadge}`}></div>
          </td>
          <td>
            <div className={`${styles.skeleton} ${styles.skeletonBadge}`}></div>
          </td>
          <td>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "60%" }}
            ></div>
          </td>
          <td>
            <div className={`${styles.skeleton} ${styles.skeletonIcon}`}></div>
          </td>
        </tr>
      ))}
    </>
  );
};

const Table = ({
  users,
  loading,
  handlePromoteAsAssociate,
}: {
  users: any[];
  loading?: boolean;
  handlePromoteAsAssociate: () => void;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageSizeChange = (newSize: number) => {
    setItemsPerPage(newSize);
    setCurrentPage(1);
  };
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>KYC Status</th>
            <th>Login Status</th>
            <th>Created On</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <TableSkeleton rows={itemsPerPage} />
          ) : currentUsers?.length > 0 ? (
            currentUsers.map((user: any) => (
              <tr key={user.CustomerID}>
                <td className={styles.nameCell}>
                  <UserAvatar
                    src={`${user.ProfileFilePath}${user.ProfileImage}`}
                    alt={user.CustomerName}
                  />
                  <div>
                    <div className={styles.userName}>
                      {user.Solutation} {user.CustomerName}
                    </div>
                    <div className={styles.userCode}>{user.CustomerCode}</div>
                  </div>
                </td>

                <td>
                  <div className={styles.iconWrapper}>
                    <MdPhone className={styles.rowIcon} />
                    {user.PrimaryMobile}
                  </div>
                </td>

                <td>
                  {user.EmailID ? (
                    <a
                      href={`mailto:${user.EmailID}`}
                      className={styles.emailLink}
                    >
                      <MdEmail className={styles.rowIcon} />
                      {user.EmailID}
                    </a>
                  ) : (
                    <span className={styles.notAvailable}>N/A</span>
                  )}
                </td>

                <td>
                  <div className={styles.statusWrapper}>
                    {user.KYCStatus === "Y" ? (
                      <MdVerifiedUser color="#4caf50" />
                    ) : (
                      <MdErrorOutline color="#ff9800" />
                    )}
                    <StatusBadge
                      status={user.KYCStatus === "Y" ? "Verified" : "Pending"}
                    />
                  </div>
                </td>

                <td>
                  <StatusBadge
                    status={user.Status === "Y" ? "Active" : "Inactive"}
                  />
                </td>
                <td>
                  <div className={styles.iconWrapper}>
                    <MdCalendarToday className={styles.rowIcon} />
                    {user.CreatedOn}
                  </div>
                </td>

                <td>
                  <ActionMenu
                    handlePromoteAsAssociate={handlePromoteAsAssociate}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={7}
                className={`${styles.noDataCell} ${styles.textDanger}`}
              >
                No users found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {!loading && (
        <div className={styles.paginationWrapper}>
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={users.length}
            currentPage={currentPage}
            onPageChange={paginate}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default Table;
